import React from 'react'
import * as styles from './styles.module.scss'
import { Content as Footer } from 'components/shared/Footer'
import { BottomWavedContainer as BodyWrapper } from 'components/WavedContainer'
import { Helmet } from 'react-helmet'

/**
 */
export const Body = ({ children }) => (
  <BodyWrapper>
    <div className={styles.Body}>{children}</div>
  </BodyWrapper>
)

/**
 */
export const Container = ({ children }) => (
  <div className={styles.Container}>{children}</div>
)

/**
 */
export const Layout = ({ children, metaTitle }) => (
  <Container>
    <Helmet>
      <title>カタログにはない建材のストーリーを。</title>
      <meta name="非表示のページです" content="noindex" />
    </Helmet>
    <Body>{children}</Body>
    <Footer />
  </Container>
)
